import { ExclamationIcon } from '@heroicons/react/outline';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { createBrowserHistory } from 'history';

type Props = {
  code: string;
  message: string;
  to: string;
  toMessage?: string;
};

const ErrorCode = ({
  code,
  message,
  to,
  toMessage = 'Take me to the dashboard',
}: Props) => {
  const chistory = createBrowserHistory({ forceRefresh: true });

  return (
    <div className='bg-gray-500 flex flex-col w-full items-center justify-center'>
      <div className='flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0'>
        {/* This element is to trick the browser into centering the modal contents. */}
        <span
          className='hidden sm:inline-block sm:align-middle sm:h-screen'
          aria-hidden='true'
        >
          &#8203;
        </span>
        <div className='inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full'>
          <div className='bg-white py-5 px-5'>
            <div className='sm:flex sm:items-start'>
              <div className='mx-auto flex-shrink-0 flex items-center justify-center h-16 w-16 rounded-full bg-red-100 sm:mx-0 sm:h-16 sm:w-16'>
                <ExclamationIcon
                  className='h-12 w-12 text-red-600'
                  aria-hidden='true'
                />
              </div>
              <div className='mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left'>
                <h2 className='text-gray-900'>{code}</h2>
                <div className='mt-2'>
                  <p className='text-base text-gray-900'>{message}</p>
                </div>
              </div>
            </div>
          </div>
          <div className='bg-gray-50 px-5 py-4 sm:flex sm:flex-row-reverse'>
            <button
              onClick={() => chistory.push(to)}
              type='button'
              className='w-full inline-flex justify-center rounded-md border-gray-300 shadow-sm px-4 py-2 bg-gray-900 text-base font-medium text-gray-50 hover:bg-gray-800 focus:outline-none sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm'
            >
              {toMessage}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorCode;
